import { axiosService } from "./axiosService";

const localeApi = {
    getLangs() {
        const url = '/locale/languages';
        return axiosService.get(url)
    },
    getMessages() {
        const url = '/locale/messages';
        return axiosService.get(url)
    },
}

export default localeApi;